import { Component, AfterViewInit } from '@angular/core';
import { ConfigurationService } from '@app/app-initialisers/configuration-service/configuration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SEOService } from '@app/shared/services/seo.service';
import { AndroWebCoreComponent } from '@app/core/AndroWebCoreComponent';

@Component({
  selector: 'app-terms-and-conditions',
  styleUrls: ['./terms-and-conditions.component.scss'],
  templateUrl: './terms-and-conditions.component.html',
})
export class TermsAndConditionsComponent extends AndroWebCoreComponent implements AfterViewInit {
  private previousUrl: string = '';

  constructor(
    private router: Router,
    private seoService: SEOService,
    private activatedRoute: ActivatedRoute,
    public configurationService: ConfigurationService,
  ) {
    super();
    const returnURL = this.activatedRoute.snapshot.queryParamMap.get('exit');

    if (returnURL) {
      this.router.navigate([], { queryParams: { id: null }, relativeTo: this.activatedRoute });
      this.previousUrl = returnURL;
    }

    this.seoService.restore();
  }

  ngAfterViewInit(): void {
    let top = document.getElementById('top');

    if (top) {
      top.scrollIntoView();
      top = null;
    }
  }

  /**
   * Navigates away from the component
   */
  public close(): void {
    this.router.navigate([this.previousUrl]);
  }
}
